import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import hoc from './hoc';
import CheckboxField from 'shared-components/reduxForms/fields/CheckboxField/CheckboxField';
import { FormattedMessage } from 'react-intl';

const DeleteSpaceModal = ({
  isChecked,
  toggleChecked,
  deleteSpace,
  showSpinner,
  errorMessage,
  ...props
}) => (
  <BootstrapModal
    {...props}
    header={
      <h3><FormattedMessage id="hosting.delete_space_modal.delete_space_heading" defaultMessage="Delete Space"/></h3>
    }
    body={
      <div>
        <div className="margin-xl-bottom">
          <FormattedMessage id="hosting.delete_space_modal.delete_space_confirmation_text" defaultMessage="Are you sure you want to delete space?"/>
        </div>
        <div className="flex start">
          <div className="margin-md-right">
            <CheckboxField
              id="deleteSpace"
              label={<FormattedMessage id="hosting.delete_space_modal.delete_space_checkbox_label" defaultMessage="I understand that this will delete all listing information associated with this space."/>}
              input={{
                onChange: toggleChecked
              }}
            />
          </div>
        </div>
      </div>
    }
    modalSize="sm-size"
    modalClass="delete-listing-modal"
    footer={
      <div>
        <div>
          <CTAButton
            buttonText={<FormattedMessage id="hosting.delete_space_modal.button_text_delete" defaultMessage="Delete"/>}
            classNameString="btn btn-primary form margin-md-bottom"
            onClickAction={deleteSpace}
            isDisabled={!isChecked}
            spinning={showSpinner}
          />
        </div>
        <div>
          <CTAButton
            buttonText={<FormattedMessage id="hosting.delete_space_modal.button_text_cancel" defaultMessage="Cancel"/>}
            classNameString="btn btn-gray-outline form"
            onClickAction={() => props.toggleModal('') }
            isDisabled={ false }
          />
        </div>
        <div className="margin-xl-top text-red text-center">{errorMessage}</div>
      </div>
    }
  />
);

DeleteSpaceModal.propTypes = {
  cancelAction: PropTypes.func,
  bodyText: PropTypes.string,
  isChecked: PropTypes.bool,
  toggleChecked: PropTypes.func,
  toggleModal: PropTypes.func,
  deleteSpace: PropTypes.func,
  showSpinner: PropTypes.bool,
  errorMessage: PropTypes.string
};

export default hoc(DeleteSpaceModal);
